import { call, put, takeLatest, take, all } from "redux-saga/effects";
import {
    directDebitList,
    directDebitCreatePre,
    directDebitCreatePreview,
    directDebitSend,
    downloadDirectDebitDetailFileMiddleware,
} from "middleware/directDebit";
import { downloadPdf, downloadXls } from "util/download";

import { actions as notificationActions } from "reducers/notification";
import { VALIDATION_ERROR } from "util/responses";
import { actions as formActions } from "reducers/form";
import { types } from "reducers/directDebit";
import { replace } from "react-router-redux";
import * as i18n from "util/i18n";
import * as configUtils from "util/config";

const sagas = [
    takeLatest(types.LIST_DIRECT_DEBIT_REQUEST, requestDirectDebitList),
    takeLatest(types.DIRECT_DEBIT_CREATE_PRE_REQUEST, requestDirectDebitCreatePre),
    takeLatest(types.DIRECT_DEBIT_PREVIEW_REQUEST, requestDirectDebitPreview),
    takeLatest(types.DIRECT_DEBIT_SEND_REQUEST, requestDirectDebitSend),
    takeLatest(types.DOWNLOAD_DETAIL_FILE_REQUEST, downloadDirectDebitDetailRequest),
];

export default sagas;

function* requestDirectDebitList({ valuesForm, isDesktop }) {
    const response = yield call(directDebitList, valuesForm);
    if (response.type === "W") {
        yield put(notificationActions.showNotification(response.data.message, "error", ["directDebit"], null, false));
        yield put({ type: types.LIST_DIRECT_DEBIT_FAILURE });
    } else {
        const { listDirectDebit, totalPages, pageNumber } = response.data.data;
        yield put({
            type: types.LIST_DIRECT_DEBIT_SUCCESS,
            listDirectDebit,
            totalPages,
            pageNumber,
            isDesktop,
        });
    }
}

function* requestDirectDebitCreatePre() {
    const response = yield call(directDebitCreatePre);
    if (response.type === "W") {
        yield put(notificationActions.showNotification(response.data.message, "error", ["directDebit"], null, false));
        yield put({ type: types.DIRECT_DEBIT_CREATE_PRE_FAILURE });
    } else {
        const { payrollOptions, accounts } = response.data.data;
        yield put({
            type: types.DIRECT_DEBIT_CREATE_PRE_SUCCESS,
            payrollOptions,
            accounts,
        });
    }
}

function* requestDirectDebitPreview({ valuesForm }) {
    const response = yield call(directDebitCreatePreview, valuesForm);
    if (response.type === "W") {
        const message = response?.data?.data?.message || response?.data?.message;
        yield put(notificationActions.showNotification(message, "error", ["directDebit"], null, false));

        yield put({
            type: types.DIRECT_DEBIT_PREVIEW_FAILURE,
        });
    } else {
        yield put({
            type: types.DIRECT_DEBIT_PREVIEW_SUCCESS,
            initialValues: valuesForm,
            dateUpload: response.data?.data?.dateUpload,
        });

        yield put(replace("/directDebit/summary"));
        if (response.data?.data?.showSnackbar) {
            const hour = configUtils.getInteger("time.limit.directDebitRequest.extract", 12);
            const scopes = ["directDebit", "directDebitApp"];
            const message = i18n.get("directDebit.message.warning.fileUploadHint", null, { HOUR: hour });
            yield all(
                scopes.map((scope) =>
                    put(notificationActions.showNotification(message, "warning", [scope], null, false)),
                ),
            );
        }
    }
}

function* requestDirectDebitSend({ valuesForm }) {
    const response = yield call(directDebitSend, valuesForm);

    if (response.type === "W" && response.data?.code !== "API516W") {
        if (response.data?.code === VALIDATION_ERROR) {
            if (response.data.data.NO_FIELD) {
                yield put(
                    notificationActions.showNotification(
                        response.data.data.NO_FIELD,
                        "error",
                        ["directDebit"],
                        null,
                        false,
                    ),
                );
            } else {
                yield put(
                    notificationActions.showNotification(
                        response.data.data.message,
                        "warning",
                        ["directDebit"],
                        null,
                        false,
                    ),
                );
            }
        } else if (response.data?.data?.signatureError) {
            yield put(
                notificationActions.showNotification(
                    response.data.data.signatureError,
                    "error",
                    ["directDebit"],
                    null,
                    false,
                ),
            );
        } else {
            yield put(
                notificationActions.showNotification(response.data?.message, "error", ["directDebit"], null, false),
            );
        }
        yield put({ type: types.DIRECT_DEBIT_SEND_FAILURE });
    } else {
        if (response?.data?.data?.signatureError) {
            yield put(
                notificationActions.showNotification(
                    response.data.data.signatureError,
                    "error",
                    ["directDebit"],
                    null,
                    false,
                ),
            );
        }
        yield put(
            formActions.readTransaction({
                pathname: `/transaction/${response.data?.idTransaction}`,
                newTransaction: true,
            }),
        );
        yield put({ type: types.DIRECT_DEBIT_SEND_SUCCESS });
        yield take("READ_TRANSACTION_REQUEST");
    }
}

function* downloadDirectDebitDetailRequest({ format, idTransaction }) {
    const { data, type } = yield call(downloadDirectDebitDetailFileMiddleware, format, idTransaction);

    if (type === "W") {
        yield put({ type: types.DOWNLOAD_DETAIL_FILE_FAILURE });
        yield put(
            notificationActions.showNotification(
                i18n.get("global.unexpectedError"),
                "error",
                ["directDebit"],
                null,
                false,
            ),
        );
    } else {
        const { content, fileName } = data.data;

        if (format === "pdf") {
            downloadPdf(fileName, content);
        } else {
            downloadXls(fileName, content);
        }

        yield put({ type: types.DOWNLOAD_DETAIL_FILE_SUCCESS });
        yield put(
            notificationActions.showNotification(
                i18n.get("global.successDownload"),
                "success",
                ["directDebit"],
                null,
                false,
            ),
        );
    }
}
